import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Typography, createTheme, ThemeProvider,
} from '@mui/material';
import useAboutStyle from '../../styles/AboutStyles.jsx';

const theme = createTheme();

const About = ({ isMobile }) => {
  const {
    root,
    aboutContainer,
    header,
    biography,
    headerSecondary,
    titleDate,
    list,
    listItem,
    link,
    // headerMobile,
    // headerSecondaryMobile,
    textMobile,
  } = useAboutStyle();

  // const headerClass = isMobile ? `${header} ${headerMobile}` : header;
  // const headerSecondaryClass = isMobile ? `
  // ${headerSecondary} ${headerSecondaryMobile}` : headerSecondary;
  const listItemClass = isMobile ? `${listItem} ${textMobile}` : listItem;

  return (
    <ThemeProvider theme={theme}>
      <Box className={root}>
        <Box className={aboutContainer}>

          <Typography className={header}>
            About
          </Typography>
          <Typography className={listItemClass}>
            Hi! I&apos;m Tingjun. A software engineer with a background in Economics and Psychology.
          </Typography>

          <Typography className={`${listItemClass} ${biography}`}>
            Still in the process of exploring &apos;Who I am&apos;, but -- love the idea of blending
            human science with software engineering, love travelling and accidentally taking great
            photographs, love cocktail mixing as a professional amateur and LOVE cats!
          </Typography>

          <Typography className={headerSecondary}>
            Professional Experience
          </Typography>

          <ul className={list}>
            <li className={listItemClass}>

              <Box className={titleDate}>
                <span>Software Engineer</span>
                {!isMobile && <span>Oct 2022 - Aug 2023</span>}
              </Box>

              <ul className={list}>
                {isMobile && <li className={listItemClass}>
                  <span>Oct 2022 - Aug 2023</span>
                </li>}
                <li className={listItemClass}>
                  <a className={link} href='https://www.humu.com/' target='_blank' rel="noreferrer">Humu, Inc.</a>
                </li>
                <li className={listItemClass}>
                Participated in full-stack projects, implemented client-facing
                applications with cross-device compatibility,
                enhanced accessibility and content localization
                using React and related packages (react-router, styled-components)
                </li>
                <li className={listItemClass}>
                Optimized data retrieval and manipulation processes by modifying
                GraphQL queries and resolvers, ensuring efficient
                and seamless communication between the frontend and backend systems
                </li>
                <li className={listItemClass}>
                Successfully migrated Elasticsearch data from a GCP-hosted cluster to
                an Elastic Cloud-hosted cluster, resulting
                in enhanced robustness (eliminating out-of-memory issues) and increased
                efficiency (80% reduction in migration time)
                </li>
                <li className={listItemClass}>
                Provided technical guidance to junior teammates, offering support for
                troubleshooting and code reviews
                </li>
                <li className={listItemClass}>
                Collaborated closely with engineers and cross-functional teams throughout
                the development cycle, ensuring effective
                communication, streamlined processes, and timely product delivery
                </li>
              </ul>
            </li>
            <li className={listItemClass}>

              <Box className={titleDate}>
                <span>Software Engineer - Frontend</span>
                {!isMobile && <span>Nov 2020 - Oct 2021</span>}
              </Box>

              <ul className={list}>
                {isMobile && <li className={listItemClass}>
                  <span>Nov 2020 - Oct 2021</span>
                </li>}
                <li className={listItemClass}>
                  <a className={link} href='https://groundspeed.com/' target='_blank' rel="noreferrer">Groundspeed Analytics, Inc.</a>
                </li>
                <li className={listItemClass}>
                  Developed in-house data annotation UIs for 100+ internal users,
                  wrote unit tests with Jest and React Testing Library, modeled and
                  created API endpoints to support front-end applications
                </li>
                <li className={listItemClass}>
                  Contributed to the maintenance and optimization of legacy codebase,
                  identifying and resolving technical debts to improve efficiency and performance
                </li>
                <li className={listItemClass}>
                  Collaborated with cross-functional teams, including product owners, UX designers,
                  and operations managers, to design and deliver high-quality web products
                </li>
              </ul>
            </li>

            <li className={listItemClass}>
              <Box className={titleDate} >
                <span>Data Analyst</span>
                {!isMobile && <span>Aug 2019 - Nov 2020</span>}
              </Box>

              <ul className={list}>
                {isMobile && <li className={listItemClass}>
                  <span>Aug 2019 - Nov 2020</span>
                </li>}
                <li className={listItemClass}>
                  <a className={link} href='https://groundspeed.com/' target='_blank' rel="noreferrer">Groundspeed Analytics, Inc.</a>
                </li>
                <li className={listItemClass}>
                  Extracted, transformed and organized unstructured data from various
                  insurance documents, performed quality assurance and audits, enriched
                  training corpus for automatic data annotation
                </li>
              </ul>
            </li>
          </ul>

          <Typography className={headerSecondary}>
            Education
          </Typography>

          <ul className={list}>
            <li className={listItemClass}>
              <Box className={titleDate} >
                <span>Advanced Software Engineering Immersive</span>
                {!isMobile && <span>May 2021 - Jan 2022</span>}
              </Box>
              <ul className={list}>
                {isMobile && <li className={listItemClass}>
                  <span>May 2021 - Jan 2022</span>
                </li>}
                <li className={listItemClass}><a className={link} href='https://www.hackreactor.com/' target='_blank' rel="noreferrer">Hack Reactor</a></li>
              </ul>
            </li>

            <li className={listItemClass}>
              <Box className={titleDate} >
                <span>M.A. in Psychology (STEM)</span>
                {!isMobile && <span>Sep 2017 - May 2019</span>}
              </Box>

              <ul className={list}>
                {isMobile && <li className={listItemClass}>
                  <span>Sep 2017 - May 2019</span>
                </li>}
                <li className={listItemClass}><a className={link} href='https://www.nyu.edu/' target='_blank' rel="noreferrer">New York University</a></li>
              </ul>
            </li>

            <li className={listItemClass}>
              <Box className={titleDate} >
                <span>B.Sc. in Economics and Finance</span>
                {!isMobile && <span>Aug 2013 - July 2017</span>}
              </Box>

              <ul className={list}>
                {isMobile && <li className={listItemClass}>
                  <span>Aug 2013 - July 2017</span>
                </li>}
                <li className={listItemClass}>
                  <a className={link} href='https://hkust.edu.hk/home' target='_blank' rel="noreferrer">The Hong Kong University of Scrience and Technology</a>
                </li>
                <li className={listItemClass}>Minor in Social Science</li>
              </ul>
            </li>
          </ul>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

About.propTypes = {
  isMobile: PropTypes.bool,
};

export default About;
